import React from "react";
import ReactDOM from "react-dom";
import { Video } from "./video";
import { PlayButton } from "./play-button";
import { LoadButton } from "./load-button";
import { InvertButton } from "./invert-button";
import { VideoTimer } from "./video-timer";

import "./styles.css";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.wrapVideo = this.wrapVideo.bind(this);
    this.renderVideo = this.renderVideo.bind(this);
    this.state = {
      wrap: false
    };
  }

  wrapVideo() {
    this.setState(function(state) {
      return { wrap: !state.wrap };
    });
  }

  renderVideo() {
    if (this.state.wrap) {
      return (
        <div className="wrapper-div">
          <Video />
        </div>
      );
    } else {
      return <Video />;
    }
  }

  render() {
    return (
      <div className="App">
        {this.renderVideo()}
        <LoadButton />
        <PlayButton />
        <InvertButton />
        <button onClick={this.wrapVideo}>
          {this.state.wrap ? "Unwrap video" : "Wrap video"}
        </button>
        <VideoTimer />
      </div>
    );
  }
}

ReactDOM.render(<App />, document.getElementById("root"));
